import { render } from "./LinkedInLogin.vue?vue&type=template&id=36c185e4"
import script from "./LinkedInLogin.vue?vue&type=script&lang=js"
export * from "./LinkedInLogin.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__